import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ReportGraph from "../../pages/ReportGraph";
import CubeReqMapper from "../../utils/CubeReqMapper";
//import profileReports from '../../utils/profileSpecificReportsData';
import { handleLanguageChange } from '../../utils/multiLangDashboardV2Data';
import settings from "../../config/settings";


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p="5px">
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
}));

const getText = (txt) => {
  if(/\((.*)\)/.test(txt)) return txt.match(/\((.*)\)/)[1];
  return txt;
}
export default function ReportServiceTabs({selectedReports, measureTitle, dimensionTitle,onTabSelected,selectedProfile,profileReportIds,loadProfile}) {
  
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [reports,setReports] = useState([])
   
  useEffect(()=> {
     let report = []
      if(loadProfile) {
        if(profileReportIds.length) {
            for(let rep of selectedReports) {
              if(profileReportIds.includes(rep?._id)) {
                report.push(rep)
              }
            }
        }
        else {
            report = selectedReports
        }
         setReports(report)
      }
  },[selectedProfile,profileReportIds,loadProfile])

  const handleChange = (event, newValue) => {
    setValue(newValue);
    onTabSelected(reports[newValue])
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" color="default" className="er-reports-tabs-header">
        <Tabs
          className="er-report-tabs"
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
        >
             {
                reports?.map((option, i) =>
                    <Tab key={i} className="er-report-tab-menuitem" label={handleLanguageChange(getText(option?.reportName))} {...a11yProps(i)} />
                )
            }
         
        </Tabs>
      </AppBar>
      <Box className='er-report-tabs-content'>
      {
          reports?.map((option, i) =>
          <TabPanel value={value} index={i}>

            { <ReportGraph reportDetails={CubeReqMapper(option, [{ ...measureTitle[option?._id], ...dimensionTitle[option?._id] }])} openToolBar={false} />
            }
          </TabPanel>
          )
      }
      </Box>
    
      
    </div>
  );
}
